import * as React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import { CREATE_PIPELINE_LABEL, UPGRADE_POPOVER_PIPELINE_CONTENT } from '@constants/pipelines';
import UpgradePopover from '@modules/Upgrade/components/upgradePopover/UpgradePopover';
import { FREE_TIER_LIMITS } from '@modules/Upgrade/consts/pricing';

interface Props {
  totalPipelines: number;
  isLimitedUser: boolean;
  handleMenuCreatePipelineClick: () => void;
}

const RenderCreatePipelineDropdown: React.FC<Props> = ({
  totalPipelines,
  isLimitedUser,
  handleMenuCreatePipelineClick,
}) => {
  return isLimitedUser && totalPipelines >= FREE_TIER_LIMITS.PIPELINES ? (
    <UpgradePopover description={UPGRADE_POPOVER_PIPELINE_CONTENT}>
      <Button type="primary">
        <Space>{CREATE_PIPELINE_LABEL}</Space>
      </Button>
    </UpgradePopover>
  ) : (
    <Button icon={<PlusOutlined />} type="primary" onClick={() => handleMenuCreatePipelineClick()}>
      <Space>{CREATE_PIPELINE_LABEL}</Space>
    </Button>
  );
};

export default RenderCreatePipelineDropdown;
